'use strict'

const crypto = require('crypto');


var key = "b4bfd5c30c57d17a";
const iv = '6ade12f5c1106605';


function encrypt(text) {
    var cipher = crypto.createCipheriv('aes-128-cbc',key,iv);
    return cipher.update(text, 'utf8', 'base64') + cipher.final('base64');
}

function decrypt(text) {
    var decryptor = crypto.createDecipheriv('aes-128-cbc', key, iv);
    return decryptor.update(text, 'base64', 'utf8') + decryptor.final('utf8');
}


function encryptCustom(text, iv2) {
    var cipher = crypto.createCipheriv('aes-128-cbc',key,iv2);
    return cipher.update(text, 'utf8', 'base64') + cipher.final('base64');
}

function decryptCustom(text, iv2) {
    var decryptor = crypto.createDecipheriv('aes-128-cbc', key, iv2);
    return decryptor.update(text, 'base64', 'utf8') + decryptor.final('utf8');
}

module.exports =  {
    encrypt,
    decrypt,
    encryptCustom,
    decryptCustom
};